import { FC, useState } from 'react';
import {
  useTranslation,
  Tabs,
  SelectorType,
  TabDesign,
  TabLayout,
  Theme,
  scrollToElementId,
  type TabData,
} from '@nextgen-web-framework/all';
import type { PDPNavigatorProps } from './types/propTypes';
import style from './PDPNavigator.module.scss';

const PDPNavigator: FC<PDPNavigatorProps> = (props: PDPNavigatorProps): JSX.Element => {
  const { tabsCollection } = props;
  const t = useTranslation();
  const [tabSelected, setTabSelected] = useState<number>(0);
  const tabList = tabsCollection.reduce((acc: TabData[], { title, id, display }) => {
    if (display) {
      acc.push({ title: t(title), id, dataTabScrollId: id });
    }
    return acc;
  }, []);

  return (
    <header className={`${style['cpw-header-container']} sticky-top-bar`} data-testid="page-control-btn-tray">
      <div className={style['cpw-page-controls']}>
        <Tabs
          layout={TabLayout.HORIZONTAL}
          tabList={tabList}
          theme={Theme.BLACK}
          design={TabDesign.PILL}
          selectedTab={tabSelected}
          selectorType={SelectorType.CIRCLE}
          onTabClick={(index) => {
            setTabSelected(index);
            scrollToElementId(tabList[index].id, -20);
          }}
          className={style['tab-controls']}
        />
      </div>
    </header>
  );
};

export default PDPNavigator;
